import { StateProps } from 'Container/App/interface';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { replacePlaceholders } from '@vfde-sails/utils';

/**
 * Return subline for device configuration
 */
export const getDeviceSubline = (state: Pick<StateProps, 'device' | 'customerConfig'>, withDeviceName = false) => {
    const { customerConfig: { insurance = null } = {}, device: hardware } = state;
    const { withAddons, insurance: insuranceLabel } = window[ADDITIONAL_PAGE_OPTIONS];
    const { modelName: deviceName = '' } = hardware || {};

    if (insurance) {
        return replacePlaceholders(withAddons!, {
            device: (withDeviceName && deviceName) || '',
            addons: insuranceLabel,
        }).trim();
    }

    return (withDeviceName && deviceName) || undefined;
};
